export default {
  states: '',
  departments: '',
  functions: '',
  roles: '',
  marital_status: '',
  genders: '',
  months_of_the_year: '',
  authorizations: '',
  permissions: '',
  status: '',
  paychecks: '',
  scale_types: '',
}
